/**
 * Whether a `nodes` realtime event puts a node in the store that the store did not hold (app#436).
 *
 * ⚠⚠ THE NODE-DERIVED STORES HOLD ROWS ONLY FOR THE NODES OF THE LAST FULL READ. `useServices`
 * and `useUpgrades` read with `.in('node_id', <the loaded node ids>)`, and realtime carries
 * changes, never the rows that exist. So a node that enters the store later has no services and
 * no pending upgrade until something reads them for it. The node page showed zero services, and
 * the user published them again.
 *
 * The usual case: the default `hideOffline` filter drops a node that was offline for more than
 * OFFLINE_NODE_VISIBILITY_HOURS, the node connects again, and its UPDATE pushes it into the store.
 *
 * ⚠ The caller reads `held` BEFORE it applies the event. A tombstone does not enter the store
 * (`useNode.update` drops it), so it reads nothing.
 */
export function nodeEntersStore(
  eventType: 'INSERT' | 'UPDATE' | 'DELETE',
  held: unknown,
  incoming: { deletedAt?: string | null }
): boolean {
  if (eventType === 'DELETE' || incoming.deletedAt) return false
  return eventType === 'INSERT' || !held
}
